import Konva from 'konva';
import Game from './game';
import { MODES, SIZE_MATRIX, STATUSES, TABLE } from './constants';
import { DiagramState } from './types';

export class SandboxGame {
	game: Game;
	constructor(stage: Konva.Stage) {
		this.game = new Game({ stage, tables: [] });
		this.createGameField();
	}

	createGameField() {
		// this.game.stage.content.childNodes[0].style = "border: 1px solid green;";
		this.game?.setMode(MODES.STATIC);
		this.testAllShapes(true);
		this.testMain(false);
		this.testRotations(false);
		this.testTableRects(false);
		// this.game.resources.forEach(r => r.setActive(true))
		// this.game.resources.forEach(t => t.rotate(90))
	}

	private testAllShapes(enable = true): void {
		if(!enable) return;

		SIZE_MATRIX

		const addTables = (type: any, sizesArray: any, size: any, y: any) => {
			for (let i = 0; i < sizesArray.length; i++) {
				const table = this.game.addTable({
					form: type,
					capacity: sizesArray[i],
					name: `${i},${0}`,
					booked: 5,
					size: size,
					timeLabel: '20:00',
				});
				table.setActive(true);
				
				table.element.x(200 * i);
				table.element.y(y);
				table.rotate(90);
				table.setGuestName('guest'+ i);
			}
		}


		addTables(TABLE.FORMS.CIRCLE, SIZE_MATRIX.CIRCLE.S, TABLE.SIZES.S, 0);
		addTables(TABLE.FORMS.CIRCLE, SIZE_MATRIX.CIRCLE.M, TABLE.SIZES.M, 100);
		addTables(TABLE.FORMS.CIRCLE, SIZE_MATRIX.CIRCLE.L, TABLE.SIZES.L, 200);
		addTables(TABLE.FORMS.CIRCLE, SIZE_MATRIX.CIRCLE.L, TABLE.SIZES.XL, 320);

		addTables(TABLE.FORMS.RECT, SIZE_MATRIX.RECT.S, TABLE.SIZES.S, 520);
		addTables(TABLE.FORMS.RECT, SIZE_MATRIX.RECT.M, TABLE.SIZES.M, 600);
		addTables(TABLE.FORMS.RECT, SIZE_MATRIX.RECT.L, TABLE.SIZES.L, 700);

		addTables(TABLE.FORMS.QUAD, SIZE_MATRIX.RECT.S, TABLE.SIZES.S, 850);
		addTables(TABLE.FORMS.QUAD, SIZE_MATRIX.RECT.M, TABLE.SIZES.M, 950);
		addTables(TABLE.FORMS.QUAD, SIZE_MATRIX.RECT.L, TABLE.SIZES.L, 1050);

		this.game.resources.forEach(table => {
			table.changeAppearence('', '');
			table.setDiagramColors('pink', 'green')
			table.setDiagram(DiagramState.hide, .5);

			table.setIcon('https://png.pngtree.com/element_our/20190530/ourmid/pngtree-correct-icon-image_1267804.jpg');

			table.setTimeLabel('18:00asdasd', 'red');
		})
		
		// setInterval(() => {
		// 	this.game.resources.forEach(table => {
		// 		table.setIcon('http://localhost:5173/hallmap/icons/natural.png');
		// 	})
		// }, 1000);
	}

	private testTableRects(enable = true): void {
		if(!enable) return;

		const capacity = 10;
		const t1 = this.game.addTable({
			form: TABLE.FORMS.RECT,
			capacity: capacity,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.S,
		});
		t1.setStatus(STATUSES.WAITING);
		t1.setName('1');
		t1.setGuestName('vldsfj fdsdf');

		t1.element.x(100);
		t1.element.y(200);

		const t2 = this.game.addTable({
			form: TABLE.FORMS.RECT,
			capacity: capacity,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.M,
		});
		t2.setStatus(STATUSES.ENDING);
		t2.setName('2');
		t2.setBooked(5);
		t2.setGuestName('vldsfj fdsdf');

		t2.element.x(250);
		t2.element.y(200);

		const t3 = this.game.addTable({
			form: TABLE.FORMS.RECT,
			capacity: capacity,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.L,
		});
		t3.setStatus(STATUSES.WAITING);
		t3.setName('3');
		t3.setGuestName('vldsfj fdsdf');

		t3.element.x(450);
		t3.element.y(200);

		[t1,t2,t3].forEach(t => t.setActive(true))
	}

	private testRotations(enable = true): void {
		if(!enable) return;

		for (let i = 0; i < 5; i++) {
			for (let j = 0; j < 5; j++) {
				const x = (300 * j);
				const y = (300 * i);

				const table = this.game.addTable({
					form: TABLE.FORMS.RECT,
					capacity: 10,
					name: `${i},${j}`,
					booked: 5,
					size: TABLE.SIZES.L,
				});
				table.setActive(true);

				table.element.x(x);
				table.element.y(y);
				
				// table.rotate(Math.ceil(Math.random() * 360));
				table.rotate(90);
				table.setStatus(STATUSES.WAITING)
				table.setGuestName('guest ' + j);
				// table.setDiagram('exceeding',.5);
				
			}

		}
		
		const t8 = this.game.addTable({
			form: TABLE.FORMS.RECT,
			capacity: 6,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.L,
		});
		t8.setActive(true);
		t8.element.x(200);
		t8.element.y(200);
		t8.rotate(40);
		t8.setGuestName(`guest`);
		t8.setStatus(STATUSES.WAITING);
		t8.setBooked(4)
		
		const t13 = this.game.addTable({
			form: TABLE.FORMS.CIRCLE,
			capacity: 3,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.M,
		});
		t13.setActive(true);
		t13.setGuestName(`guest quad`);
		t13.setStatus(STATUSES.WAITING);
		t13.setBooked(4)

		t13.rotate(130)
		let r = 0;
		const animation = () => {
			requestAnimationFrame(animation);
			t8.rotate(r++);
			t8.setGuestName(`guest ${r % 360}`);
			t8.setName('101');
		}

		animation();

	}

	private testMain(enable = true) : void{
		if(!enable) return;

		const t1 = this.game.addTable({
			form: TABLE.FORMS.SQUARE,
			capacity: 2,
			name: 's2',
			booked: 4,
			size: TABLE.SIZES.S,
		});
		t1.setStatus(STATUSES.FREE);
		t1.isActive = false;
		// t1.element.y(100);
		t1.setInactiveAppearence();

		// t1.element.x(-300);



		t1.onClick = () => {
		};
		t1.onUpdate = () => {
		};

		const t2 = this.game.addTable({
			form: TABLE.FORMS.SQUARE,
			capacity: 4,
			name: 's4',
			booked: 2,
			size: TABLE.SIZES.S,
		});
		t2.setStatus(STATUSES.WAITING);
		// t2.element.x(100);
		// t2.element.y(-500);
		t2.setSelectable(false);

		t1.element.x(-500);
		t1.element.y(-500);

		t2.element.x(500);
		t2.element.y(500 );

		const t3 = this.game.addTable({
			form: TABLE.FORMS.SQUARE,
			capacity: 4,
			name: 'm4',
			booked: 2,
			size: TABLE.SIZES.M,
		});

		t3.setStatus(STATUSES.DELAY);
		t3.element.x(0);
		t3.element.y(-400);
		t3.isActive = false;

		const t4 = this.game.addTable({
			form: TABLE.FORMS.SQUARE,
			capacity: 6,
			name: 'm6',
			booked: 2,
			size: TABLE.SIZES.M,
		});
		t4.setStatus(STATUSES.BUSY);
		t4.element.x(100);
		t4.element.y(-400);

		const t5 = this.game.addTable({
			form: TABLE.FORMS.SQUARE,
			capacity: 6,
			name: 'l6',
			booked: 2,
			size: TABLE.SIZES.L,
		});
		t5.setStatus(STATUSES.ENDING);
		t5.element.y(-300);

		const t6 = this.game.addTable({
			form: TABLE.FORMS.SQUARE,
			capacity: 8,
			name: 'l8',
			booked: 5,
			size: TABLE.SIZES.L,
		});
		t6.isSelectable = false;
		t6.setStatus(STATUSES.WAITING);
		t6.element.y(-300);
		t6.element.x(150);

		const t71 = this.game.addTable({
			form: TABLE.FORMS.SQUARE,
			capacity: 10,
			name: 'l10',
			booked: 5,
			size: TABLE.SIZES.L,
			rotation: TABLE.ROTATIONS.RECTV,
		});
		t71.element.y(-300);
		t71.element.x(350);

		const t72 = this.game.addTable({
			form: TABLE.FORMS.SQUARE,
			capacity: 8,
			name: 'xl8',
			booked: 5,
			size: TABLE.SIZES.XL,
		});
		t72.element.y(-200);
		const window2: any = window;
		window2.tXl8 = t72;

		const t73 = this.game.addTable({
			form: TABLE.FORMS.SQUARE,
			capacity: 10,
			name: 'xl10',
			booked: 5,
			size: TABLE.SIZES.XL,
		});
		t73.element.y(-200);
		t73.element.x(200);

		const t74 = this.game.addTable({
			form: TABLE.FORMS.SQUARE,
			capacity: 12,
			name: 'xl12',
			booked: 5,
			size: TABLE.SIZES.XL,
			isSelectable: false,
			isActive: false,
		});
		t74.element.y(-200);
		t74.element.x(450);

		const t7 = this.game.addTable({
			form: TABLE.FORMS.QUAD,
			capacity: 4,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.S,
		});
		t7.setStatus(STATUSES.WAITING);
		t7.setName('1010');
		t7.setBooked(3);
		t7.element.x(50);
		t7.element.y(200);
		t7.setGuestName('sagdfsdlf jsd')

		const t8 = this.game.addTable({
			form: TABLE.FORMS.QUAD,
			capacity: 8,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.M,
		});
		t8.setStatus(STATUSES.WAITING);
		t8.setName('1011');
		t8.element.x(200);
		t8.element.y(200);

		const t9 = this.game.addTable({
			form: TABLE.FORMS.QUAD,
			capacity: 12,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.L,
		});
		t9.setStatus(STATUSES.WAITING);
		t9.setName('1012');
		t9.element.x(350);
		t9.element.y(200);

		// circle
		const t10 = this.game.addTable({
			form: TABLE.FORMS.CIRCLE,
			capacity: 2,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.S,
		});
		t10.setName('s2');
		t10.element.x(100);
		t10.element.y(400);
		t10.setStatus(STATUSES.WAITING);

		const t11 = this.game.addTable({
			form: TABLE.FORMS.CIRCLE,
			capacity: 3,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.S,
		});
		t11.setName('s3');
		t11.element.x(200);
		t11.element.y(400);
		t11.setStatus(STATUSES.WAITING);

		const t12 = this.game.addTable({
			form: TABLE.FORMS.CIRCLE,
			capacity: 4,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.S,
		});
		t12.setName('s4');
		t12.element.x(300);
		t12.element.y(400);
		t12.setStatus(STATUSES.WAITING);
		//
		const t13 = this.game.addTable({
			form: TABLE.FORMS.CIRCLE,
			capacity: 3,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.M,
		});
		t13.setName('m3');
		t13.element.x(100);
		t13.element.y(500);
		t13.setStatus(STATUSES.WAITING);

		const t14 = this.game.addTable({
			form: TABLE.FORMS.CIRCLE,
			capacity: 4,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.M,
		});
		t14.setName('m4');
		t14.element.x(250);
		t14.element.y(500);
		t14.setStatus(STATUSES.WAITING);

		const t15 = this.game.addTable({
			form: TABLE.FORMS.CIRCLE,
			capacity: 5,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.M,
		});
		t15.setName('m5');
		t15.element.x(400);
		t15.element.y(500);
		t15.setStatus(STATUSES.WAITING);

		const t16 = this.game.addTable({
			form: TABLE.FORMS.CIRCLE,
			capacity: 6,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.M,
		});
		t16.setName('m6');
		t16.element.x(550);
		t16.element.y(500);
		t16.setStatus(STATUSES.WAITING);
		//
		const t17 = this.game.addTable({
			form: TABLE.FORMS.CIRCLE,
			capacity: 4,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.L,
		});
		t17.setName('l4');
		t17.element.x(100);
		t17.element.y(600);
		t17.setStatus(STATUSES.WAITING);

		const t18 = this.game.addTable({
			form: TABLE.FORMS.CIRCLE,
			capacity: 5,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.L,
		});
		t18.setName('l6');
		t18.element.x(250);
		t18.element.y(600);
		t18.setStatus(STATUSES.WAITING);

		const t19 = this.game.addTable({
			form: TABLE.FORMS.CIRCLE,
			capacity: 6,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.L,
		});
		t19.setName('l6');
		t19.element.x(400);
		t19.element.y(600);
		t19.setStatus(STATUSES.WAITING);

		const t20 = this.game.addTable({
			form: TABLE.FORMS.CIRCLE,
			capacity: 8,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.L,
		});
		t20.setName('l8');
		t20.element.x(550);
		t20.element.y(600);
		t20.setStatus(STATUSES.WAITING);
		//
		const t21 = this.game.addTable({
			form: TABLE.FORMS.CIRCLE,
			capacity: 6,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.XL,
		});
		t21.setName('xl6');
		t21.element.x(100);
		t21.element.y(750);
		t21.setStatus(STATUSES.WAITING);

		const t22 = this.game.addTable({
			form: TABLE.FORMS.CIRCLE,
			capacity: 8,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.XL,
		});
		t22.setName('xl8');
		t22.element.x(250);
		t22.element.y(750);
		t22.setStatus(STATUSES.WAITING);

		const t23 = this.game.addTable({
			form: TABLE.FORMS.CIRCLE,
			capacity: 10,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.XL,
		});
		t23.setName('xl10');
		t23.element.x(400);
		t23.element.y(750);
		t23.setStatus(STATUSES.WAITING);

		const t24 = this.game.addTable({
			form: TABLE.FORMS.CIRCLE,
			capacity: 12,
			name: 1,
			booked: 4,
			size: TABLE.SIZES.XL,
		});
		t24.setName('xl12');
		t24.element.x(550);
		t24.element.y(750);
		t24.setStatus(STATUSES.WAITING);

		const t25 = this.game.addTable({
			form: TABLE.FORMS.CIRCLE,
			capacity: 22,
			name: 'm7!!!',
			booked: 0,
			size: TABLE.SIZES.M,
			status: 'ending',
		});
		t25.element.x(700);
		t25.element.y(750);

		const t26 = this.game.addTable({
			form: TABLE.FORMS.CIRCLE,
			capacity: 1,
			name: 's1',
			booked: 0,
			size: TABLE.SIZES.S,
			status: 'ending',
		});
		t26.element.x(0);
		t26.element.y(750);

		// const z1 = this.game.addZone([t1, t2, t4, t6], '#E9F6DB')
		// const z2 = this.game.addZone([t3], 'pink')

		// this.game.removeZones([z1.id, z2.id])

		// const z3 = this.game.addZone([t1, t2, t4, t14, t9, t21, t17, t18, t7, t12, t11], 'limegreen')
		// z3;

		this.game?.resources.forEach(r => r.setActive(true));
		// this.game?.setScale(MAP_SCALES[2]);

		// t1.setStatus(STATUSES.FREE);
		// t1.setBooked(4);
		// t1.setGuestName('ALLLA');
		// t1.setDiagram('busy', 0.5);

		// t2.setStatus(STATUSES.BUSY);
		// t2.setBooked(4);
		// t2.setGuestName('ALLLA');
		// t2.setDiagram('delay', 0.6);

		// t3.setStatus(STATUSES.DELAY);
		// t3.setBooked(4);
		// t3.setGuestName('ALLLA');
		// t3.setDiagram('exceeding', 0.4);

		// t4.setStatus(STATUSES.WAITING);
		// t4.setBooked(4);
		// t4.setGuestName('Sergey');

		// t5.setStatus(STATUSES.WAITING);
		// t5.setBooked(4);
		// t5.setGuestName('Sergey');
		// t5.setDiagram('exceeding', 0.4);

		// t71.setGuestName('Sergey');
		t8.setGuestName('Sergey');

		//circles
		t10.setStatus(STATUSES.WAITING);
		t10.setBooked(4);
		t10.setGuestName('Sergey');

		t11.setStatus(STATUSES.WAITING);
		t11.setBooked(4);
		t11.setGuestName('Sergey');

		t12.setStatus(STATUSES.WAITING);
		t12.setBooked(4);
		t12.setGuestName('Sergey');

		t13.setStatus(STATUSES.WAITING);
		t13.setBooked(4);
		t13.setGuestName('Sergey');

		t17.setStatus(STATUSES.WAITING);
		t17.setBooked(4);
		t17.setGuestName('Sergey');

		t21.setStatus(STATUSES.WAITING);
		t21.setBooked(4);
		t21.setGuestName('Sergey');

		t21.element.x(-300);
		// t21.element.y(1500);
		// t21.element.x(0);
		// t21.element.y(0);
		// t7.element.x(-300);
		// console.log(t21.element.getClientRect());
		// t2.element.x(1300);
		// t2.element.x(0);
		// t2.element.y(0);

		// console.log(t1.element);


	}
}
